import api from "@/http/api";
import { useQuery } from "@tanstack/react-query";
import { METAL_OPTIONS } from "@univdiam/ui/customComponents/CatalogProduct/constants";
import { MetalButton } from "@univdiam/ui/customComponents/CatalogProduct/MetalButton";
import ProductShareView, {
    type ShareConfigItem,
} from "@univdiam/ui/customComponents/CatalogProduct/ProductShareView";
import { useParams, useSearchParams } from "react-router-dom";

const getProduct = (id: string) => {
    return api.get(`/catalog/poduct/${id}`);
};

const ShareProduct = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const quantity = searchParams.get("q") ?? 1;

    const { data } = useQuery({
        queryKey: ["product-share", id],
        queryFn: async () => getProduct(id!),
        enabled: !!id,
    });

    const selectedProduct = data?.data?.product;

    const config: ShareConfigItem[] = [];

    if (selectedProduct?.diameter) {
        config.push({ label: "Diameter", value: selectedProduct.diameter });
    }
    if (selectedProduct?.carat_weight) {
        config.push({
            label: "Carat Weight",
            value: String(selectedProduct.carat_weight),
        });
    }
    if (selectedProduct?.diamond_quality) {
        config.push({
            label: "Diamond Quality",
            value: selectedProduct.diamond_quality,
        });
    }
    if (selectedProduct?.metal_type) {
        const metal = METAL_OPTIONS.find(
            (m) =>
                m.id === selectedProduct.metal_type ||
                m.id2 === selectedProduct.metal_type
        );
        const value = metal
            ? metal.group === "Platinum"
                ? "Platinum"
                : `${metal.karat.toUpperCase()} KT ${metal.group}`
            : selectedProduct.metal_type;
        config.push({
            label: "Metal Type",
            value,
            render: metal ? (
                <MetalButton
                    label={metal.karat}
                    colorClass={metal.colorClass}
                    textColorClass={metal.textColorClass}
                    isSelected={true}
                    onClick={() => {}}
                />
            ) : undefined,
        });
    }

    return (
        <ProductShareView
            images={[]}
            title={selectedProduct?.title}
            price={Number(selectedProduct?.price || 0) * Number(quantity)}
            config={config}
            footerRows={
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                    <label className="text-gray-600 font-medium mb-2 md:mb-0">
                        Quantity:
                    </label>
                    <span className="font-medium">{quantity}</span>
                </div>
            }
        />
    );
};

export default ShareProduct;
